<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Tutor Profile</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <span @click="GoToPageNotification()">
            <!-- <CIcon name="cil-envelope-closed" class="float-right mr-3" /> -->
            <br />
            <img
              src="../assets/img/iconInbox.png"
              width="40px"
              class="float-right mr-2 mt-2"
            />
          </span>

          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>

    <CCard class="custom-card h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin">
            <CRow>
              <CCol sm="12" lg="12">
                <CRow>
                  <CCol sm="11" lg="11" class="text-center">
                    <br />
                    <CRow>
                      <CCol sm="12" lg="12" class="m-0">
                        <CRow>
                          <img
                            v-if="profiles.PicturePath == ''"
                            width="150"
                            height="150"
                            class="m-0"
                            src="../assets/img/default.png"
                          />
                          <img
                            v-else
                            width="150"
                            height="150"
                            :src="getPic(profiles)"
                            alt=""
                            style="margin: 0 auto"
                          />
                        </CRow>
                      </CCol>
                      <CCol sm="12" lg="12">
                        <CRow class="mobile-center-text">
                          <CCol sm="12" lg="12">
                            <h5 class="mt-5"><strong> TEACHER </strong></h5>
                            <h6>
                              <CIcon
                                name="cil-EnvelopeClosed"
                                style="font-size: 48px; color: black"
                              ></CIcon>
                              <span class="mt-2"> {{ profiles.Email }} </span>
                            </h6>
                            <h6 class="mt-2">
                              <CIcon
                                name="cil-people"
                                style="font-size: 48px; color: black"
                              ></CIcon>
                              <span
                                class="mt-2"
                                v-for="race in profiles.RaceList"
                                v-bind:key="race.Id"
                              >
                                {{ race.Name }}
                              </span>
                            </h6>
                          </CCol>
                        </CRow>
                      </CCol>
                      <!-- <CCol sm="2" lg="2">
                  <span class="mt-5">
                    <br />
                    <strong class="mt-5"> <i>05 Nov 09:30 AM</i></strong>
                  </span>
                </CCol> -->
                    </CRow>
                    <br />
                    <!-- <CRow>
                      <CCol sm="12" lg="12" style="text-align: center"
                        ><CIcon
                          name="cil-star"
                          style="font-size: 48px; color: green"
                        ></CIcon
                        ><CIcon
                          name="cil-star"
                          style="font-size: 48px; color: green"
                        ></CIcon
                        ><CIcon
                          name="cil-star"
                          style="font-size: 48px; color: green"
                        ></CIcon
                        ><CIcon
                          name="cil-star"
                          style="font-size: 48px; color: green"
                        ></CIcon
                        ><CIcon
                          name="cil-star"
                          style="font-size: 48px; color: green"
                        ></CIcon>
                        <span> 5.0 </span>
                      </CCol>
                    </CRow> -->
                    <!-- <CRow>
                      <CCol sm="12" lg="12" style="text-align: center"
                        ><span>(24 reviews)</span>
                      </CCol>
                    </CRow> -->
                    <hr />
                    <CCol sm="12" lg="12">
                      <CRow>
                        <CCol sm="6" lg="6">
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12">
                              <!-- <CIcon name="cil-user"></CIcon> -->
                              <h4 class="mt-2 font-weight-bold">
                                PROFESSIONAL PROFILE
                              </h4></CCol
                            >
                          </CRow>
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12"
                              ><label
                                class="mt-2"
                                v-for="pro in profiles.ProfessionalProfileList"
                                v-bind:key="pro.Id"
                              >
                                {{ pro.Name }}
                              </label>
                            </CCol>
                          </CRow>
                        </CCol>
                        <CCol sm="6" lg="6">
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12">
                              <!-- <CIcon name="cil-Briefcase"></CIcon> -->
                              <h4 class="mt-2 font-weight-bold">
                                WORK BACKGROUND
                              </h4></CCol
                            >
                          </CRow>
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12"
                              ><label
                                class="mt-2"
                                v-for="work in profiles.WorkBackgroundList"
                                v-bind:key="work.Id"
                              >
                                {{ work.Name }}
                              </label>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCol>

                    <CCol sm="12" lg="12">
                      <CRow>
                        <CCol sm="6" lg="6">
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12">
                              <!-- <CIcon name="cilList"></CIcon> -->
                              <h4 class="mt-2 font-weight-bold">
                                ACADEMIC PROFILE
                              </h4></CCol
                            >
                          </CRow>
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12"
                              ><label
                                class="mt-2"
                                v-for="acad in profiles.AcademicProfileList"
                                v-bind:key="acad.Id"
                              >
                                {{ acad.Name }}
                              </label>
                            </CCol>
                          </CRow>
                        </CCol>
                        <CCol sm="6" lg="6">
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12">
                              <!-- <CIcon name="cilDoubleQuoteSansLeft"></CIcon> -->
                              <h4 class="mt-2 font-weight-bold">
                                SKILLS
                              </h4></CCol
                            >
                          </CRow>
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12"
                              ><span class="mt-2 ml-2 badge-light badge-pill">
                                Leardership
                              </span>
                              <span class="mt-2 ml-4 badge-light badge-pill">
                                Teamwork Working
                              </span>
                              <br />
                              <span class="mt-2 ml-2 badge-light badge-pill">
                                Critical Thinking
                              </span>
                              <span class="mt-2 ml-4 badge-light badge-pill">
                                Desicion Making
                              </span>
                              <br />
                              <span class="mt-2 ml-2 badge-light badge-pill">
                                Organization and Planning
                              </span>
                              <span class="mt-2 ml-4 badge-light badge-pill">
                                Misrosoft Office
                              </span>
                              <span class="mt-2 ml-2 badge-light badge-pill"
                                >Creativity</span
                              >
                            </CCol>
                          </CRow>
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12">
                              <h4 class="mt-2 font-weight-bold">
                                TEACHING SUBJECT
                              </h4></CCol
                            >
                          </CRow>
                          <CRow class="mt-3">
                            <CCol sm="12" lg="12"
                              ><span class="mt-2 badge-primary badge-pill"
                                >Bahasa Melayu
                              </span>
                              <span class="mt-2 ml-2 badge-success badge-pill"
                                >English
                              </span>
                              <span class="mt-2 ml-2 badge-warning badge-pill"
                                >Mathematics
                              </span>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCol>
                    <hr />

                    <!-- <CCol sm="12" lg="12">
                      <CRow>
                        <CCol sm="12" lg="12">
                          <CRow class="mt-3">
                            <CCol sm="6" lg="6">
                              <h4 class="mt-2 font-weight-bold">
                                FEEDBACK
                              </h4></CCol
                            >
                            <CCol sm="6" lg="6">
                              <CRow class="float-right">
                                <h6 class="mt-2">sort by: Newest</h6>
                              </CRow>
                            </CCol>
                          </CRow>
                          <CRow class="mt-3">
                            <CCol sm="2" lg="2">
                              <CRow class="mt-3">
                                <CCol sm="12" lg="12">
                                  <img
                                    width="70"
                                    height="70"
                                    src="../assets/img/default.png"
                                  />
                                  <h6 class="mt-2"></h6>
                                </CCol>
                                <CCol sm="12" lg="12">
                                  <h6 class="mt-2">Ramli</h6>
                                </CCol>
                              </CRow>
                            </CCol>
                            <CCol sm="10" lg="10">
                              <CRow class="mt-4">
                                <CCol sm="8" lg="8"
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><br />
                                  <span
                                    ><strong>
                                      Very good teacher. Easy to understand.
                                    </strong>
                                  </span>
                                </CCol>
                                <CCol sm="4" lg="4">
                                  <span>at 2:30 pm on 3 Nov 2020</span>
                                </CCol>
                              </CRow>
                            </CCol>
                          </CRow>
                          <hr />
                          <CRow class="mt-3">
                            <CCol sm="2" lg="2">
                              <CRow class="mt-3">
                                <CCol sm="12" lg="12">
                                  <img
                                    width="70"
                                    height="70"
                                    src="../assets/img/default.png"
                                  />
                                  <h6 class="mt-2"></h6>
                                </CCol>
                                <CCol sm="12" lg="12">
                                  <h6 class="mt-2">Mei Ling</h6>
                                </CCol>
                              </CRow>
                            </CCol>
                            <CCol sm="10" lg="10">
                              <CRow class="mt-4">
                                <CCol sm="8" lg="8"
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><br />
                                  <span
                                    ><strong
                                      >Very good teacher. Easy to understand.
                                      Keep it up!</strong
                                    >
                                  </span>
                                </CCol>
                                <CCol sm="4" lg="4">
                                  <span>at 2:30 pm on 23 Oct 2020</span>
                                </CCol>
                              </CRow>
                            </CCol>
                          </CRow>
                          <hr />
                          <CRow class="mt-3">
                            <CCol sm="2" lg="2">
                              <CRow class="mt-3">
                                <CCol sm="12" lg="12">
                                  <img
                                    width="70"
                                    height="70"
                                    src="../assets/img/default.png"
                                  />
                                  <h6 class="mt-2"></h6>
                                </CCol>
                                <CCol sm="12" lg="12">
                                  <h6 class="mt-2">Ganesh</h6>
                                </CCol>
                              </CRow>
                            </CCol>
                            <CCol sm="10" lg="10">
                              <CRow class="mt-4">
                                <CCol sm="8" lg="8"
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><br />
                                  <span
                                    ><strong
                                      >Very good teacher. Easy to understand. My
                                      favourite teacher!</strong
                                    >
                                  </span>
                                </CCol>
                                <CCol sm="4" lg="4">
                                  <span>at 2:30 pm on 16 Oct 2020</span>
                                </CCol>
                              </CRow>
                            </CCol>
                          </CRow>
                          <hr />
                          <CRow class="mt-3">
                            <CCol sm="2" lg="2">
                              <CRow class="mt-3">
                                <CCol sm="12" lg="12">
                                  <img
                                    width="70"
                                    height="70"
                                    src="../assets/img/default.png"
                                  />
                                  <h6 class="mt-2"></h6>
                                </CCol>
                                <CCol sm="12" lg="12">
                                  <h6 class="mt-2">Sudin</h6>
                                </CCol>
                              </CRow>
                            </CCol>
                            <CCol sm="10" lg="10">
                              <CRow class="mt-4">
                                <CCol sm="8" lg="8"
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><br />
                                  <span
                                    ><strong>
                                      Very good teacher. Easy to understand.
                                    </strong>
                                  </span>
                                </CCol>
                                <CCol sm="4" lg="4">
                                  <span>at 2:30 pm on 13 Oct 2020</span>
                                </CCol>
                              </CRow>
                            </CCol>
                          </CRow>
                          <hr />
                          <CRow class="mt-3">
                            <CCol sm="2" lg="2">
                              <CRow class="mt-3">
                                <CCol sm="12" lg="12">
                                  <img
                                    width="70"
                                    height="70"
                                    src="../assets/img/default.png"
                                  />
                                  <h6 class="mt-2"></h6>
                                </CCol>
                                <CCol sm="12" lg="12">
                                  <h6 class="mt-2">Aminah</h6>
                                </CCol>
                              </CRow>
                            </CCol>
                            <CCol sm="10" lg="10">
                              <CRow class="mt-4">
                                <CCol sm="8" lg="8"
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><CIcon
                                    name="cil-star"
                                    style="font-size: 48px; color: green"
                                  ></CIcon
                                  ><br />
                                  <span
                                    ><strong
                                      >Very good teacher. Easy to understand.
                                      Keep it up!</strong
                                    >
                                  </span>
                                </CCol>
                                <CCol sm="4" lg="4">
                                  <span>at 2:30 pm on 3 Oct 2020</span>
                                </CCol>
                              </CRow>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCol> -->
                    <br />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";
import backgroundBanner from "../assets/img/bgApps.jpg";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

export default {
  name: "Collapses",
  components: {
    Carousel3d,
    Slide,
    MarqueeText,
  },
  data() {
    return {
      backgroundBanner,
      profiles: {},
      collapse: false,
      cardCollapse: true,
      innerCollapse: false,
      text: `
        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
        richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
        brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
        tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
        assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
        wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
        vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
        synth nesciunt you probably haven't heard of them accusamus labore VHS.
      `,
    };
  },
  async mounted() {
    await this.GetProfile();
  },
  methods: {
    getPic(profiles) {
      return "https://pickiddo.com/" + profiles.PicturePath;
    },
    async GetProfile() {
      this.$API
        .get(this.$ProfileTeacher + "?userid=" + this.$route.query.userid, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.profiles = response.data;
          }
        });
    },
    GoToPageNotification() {
      this.$router.push("/Request?userId=" + this.$route.query.studentId);
    },
  },
};
</script>